import type { EditorThemeClasses } from 'lexical';

export const lexicalTheme: EditorThemeClasses = {
  paragraph: 'lexical-paragraph',
  text: {
    bold: 'lexical-bold',
    italic: 'lexical-italic',
    strikethrough: 'lexical-strikethrough',
    underline: 'lexical-underline',
  },
  list: {
    ol: 'lexical-ol',
    ul: 'lexical-ul',
    listitem: 'lexical-listitem',
    nested: {
      listitem: 'lexical-nested-listitem',
    },
  },
};
